export * from './cotacao-acesso-fornecedor-component';